export const menuItems = [
    {
        label: "Dashboard",
        icon: "mdi mdi-apps",
        link: "/",
        perm: "view_dashboard",
    },
    {
        label: "Members",
        icon: "mdi mdi-account-multiple-plus",
        perm: "view_members",
        subItems: [
            {
                label: "Member Accounts",
                link: "/view-members",
                perm: "view_members",
            },
            {
                label: "Applicants",
                link: "/applicants",
                perm: "view_applicants",
            },
            {
                label: "Membership Fees",
                link: "/membership-fees",
                perm: "view_membershipfees",
            },
            {
                label: "Registration Fees",
                link: "/registration-fees",
                perm: "view_membershipfees",
            },
            {
                label: "Accounts Balances",
                link: "/account-balances",
                perm: "view_balances",
            },
        ],
    },
    {
        label: "Savings",
        icon: "mdi mdi-cash-multiple",
        perm: "view_savings",
        subItems: [
            {
                label: "Savings",
                link: "/savings",
                perm: "view_savings",
            },
            {
                label: "Shares",
                link: "/shares",
                perm: "view_shares",
            },
            {
                label: "Withdraws",
                link: "/withdraws",
                perm: "view_withdraws",
            },
            {
                label: "Withdraw Charges",
                link: "/withdraw-charges",
                perm: "view_withdraw_charges",
            },
        ],
    },
    {
        label: "Loans",
        icon: "mdi mdi-bank",
        perm: "view_loans",
        subItems: [
            {
                label: "Loans",
                link: "/loans",
                perm: "view_loans",
            },
            {
                label: "Loan Products",
                link: "/loan-products",
                perm: "view_loan_products",
            },

            {
                label: "Loan Charges",
                link: "/loan-charges",
                perm: "view_loan_charges",
            },
            {
                label: "Fines & Penalties",
                link: "/loan-fines",
                perm: "view_loan_products",
            },
        ],
    },
    {
        label: "Credit Score",
        // icon: "mdi mdi-new-box",
        icon: "mdi mdi-gauge",
        perm: "view_loanapplications",
        subItems: [
            {
                label: "Calculator",
                link: "/credit-score",
                perm: "view_loanapplications",
            },
            {
                label: "Credit Reports",
                link: "/credit-reports",
                perm: "view_loanapplications",
            },
        ],
    },
    // {
    //     label: "Credit Reference",
    //     icon: "mdi mdi-new-box",
    //     // icon: "mdi mdi-domain",
    //     perm: "view_loanapplications",
    //     subItems: [
    //         {
    //             label: "New Credit Report",
    //             link: "/new-crb-report",
    //             perm: "view_loanapplications",
    //         },
    //         {
    //             label: "CRB Reports",
    //             link: "/crb-reports",
    //             perm: "view_loanapplications",
    //         },
    //         {
    //             label: "Tokens",
    //             link: "/crb-tokens",
    //             perm: "view_loanapplications",
    //         },
    //     ],
    // },
    {
        label: "Checkoff List",
        icon: "mdi mdi-check-underline",
        perm: "view_dashboard",
        subItems: [
            {
                label: "New Checkoff",
                link: "/new-checkoff-list",
                perm: "view_dashboard",
            },
            {
                label: "Past Checkoffs",
                link: "/checkoff-lists",
                perm: "view_dashboard",
            },
            // {
            //     label: "Deduction Requets",
            //     link: "/deduction-requests",
            //     perm: "view_expense_items",
            // },
        ],
    },
    {
        label: "Returns",
        icon: "mdi mdi-clipboard-list",
        perm: "view_returns",
        subItems: [
            {
                label: "Investments Returns",
                link: "/investment-returns",
                perm: "view_investment_returns",
            },
            {
                label: "Investments",
                link: "/investments",
                perm: "view_investment",
            },
            {
                label: "Member Interests",
                link: "/member-interests",
                perm: "member_interests",
            },
            {
                label: "Interests Payouts",
                link: "/interest-payouts",
                perm: "interest_payouts",
            },
            {
                label: "ShareHolder Dividends",
                link: "/shareholder-dividends",
                perm: "share_holder_dividends",
            },
            {
                label: "Dividend Payouts",
                link: "/dividend-payouts",
                perm: "dividend_payouts",
            },
        ],
    },
    {
        label: "Welfare",
        icon: "mdi mdi-hand-heart",
        // icon: "mdi mdi-new-box",
        perm: "view_dashboard",
        subItems: [
            {
                label: "Contributions",
                link: "/contributions",
                perm: "view_dashboard",
            },
            {
                label: "Give Away",
                link: "/give-away",
                perm: "view_dashboard",
            },
        ],
    },
    {
        label: "Expenses",
        icon: "mdi mdi-database",
        perm: "view_expenses",
        subItems: [
            {
                label: "Record Expense",
                link: "/record-expense",
                perm: "record_expenses",
            },
            {
                label: "View Expenses",
                link: "/view-expenses",
                perm: "recorded_expenses",
            },
            {
                label: "Expense Items",
                link: "/expense-items",
                perm: "view_expense_items",
            },
            {
                label: "Expense Categories",
                link: "/expense-categories",
                perm: "view_expense_categories",
            },
        ],
    },
    {
        label: "SMS Center",
        icon: "mdi mdi-chat",
        link: "/sms-center",
        perm: "view_sms_center",
    },
    // {
    //     label: "Payments",
    //     icon: "mdi mdi-currency-usd",
    //     perm: "view_settings",
    //     subItems: [
    //         {
    //             label: "Online Transactions",
    //             link: "/online-transactions",
    //             perm: "view_system_users",
    //         },
    //         {
    //             label: "Request Payout",
    //             link: "/request-payout",
    //             perm: "view_system_users",
    //         },
    //         {
    //             label: "Payout History",
    //             link: "/payout-history",
    //             perm: "view_system_roles",
    //         },
    //     ],
    // },

    {
        label: "Documents",
        // icon: "mdi mdi-file-document-multiple",
        icon: "mdi mdi-new-box",
        perm: "view_documents",
        subItems: [
            {
                label: "New Document",
                link: "/new-document",
                perm: "add_documents",
            },
            {
                label: "Documents",
                link: "/documents",
                perm: "view_documents",
            },
            {
                label: "Document Types",
                link: "/document-types",
                perm: "view_documents",
            },
        ],
    },
    {
        label: "Settings",
        icon: "mdi mdi-cog",
        perm: "view_settings",
        subItems: [
            {
                label: "General Settings",
                link: "/settings",
                perm: "view_settings",
            },
            {
                label: "System Users",
                link: "/users",
                perm: "view_system_users",
            },
            {
                label: "System Roles",
                link: "/roles",
                perm: "view_system_roles",
            },
            {
                label: "System Permissions",
                link: "/permissions",
                perm: "system_permissions",
            },
            {
                label: "Audit Trails",
                link: "/audits",
                perm: "view_audit_trails",
            },
            {
                label: "Subscriptions",
                link: "/subscriptions",
                perm: "view_settings",
            },
        ],
    },
    {
        label: "Reports",
        icon: "mdi mdi-poll",
        link: "/reports",
        perm: "view_reports",
    },
];
